import { defineComponent } from '@vue/composition-api';
import __vue_component__ from './SbExperimentAsyncGuard.vue.js';
import __vue_component__$1 from './internal/SbExperimentComponent.vue.js';

var script = defineComponent({
    name: 'SbExperiment',
    props: {
        id: {
            type: String,
            required: true,
        },
        defaultGroup: {
            type: String,
            required: false,
            default: null,
        },
        defaultGroupWhenNotLoggedIn: {
            type: String,
            required: false,
            default: null,
        },
    },
    components: {
        SbExperimentAsyncGuard: __vue_component__,
        SbExperimentComponent: __vue_component__$1,
    },
});

export default script;
